import { Timeline } from "vue-timeline-chart";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("TimelineChart", Timeline);
});
